import { CollapsibleCard, Icon, RichTextRenderer, Space } from 'ui';

type P = {
  htmlContent?: null | string;
};

const Description = ({ htmlContent }: P) => {
  if (!htmlContent) {
    return null;
  }

  return (
    <Space align="start" className="calendar-event-description">
      <Icon icon="document-line" />
      <CollapsibleCard card={{ marginBottom: false, shrinked: true }}>
        <RichTextRenderer data={htmlContent} marginTop={false} />
      </CollapsibleCard>
    </Space>
  );
};

export default Description;
